<template>
    <!--审核应用 -->
    <vxe-modal
        v-model="isShow"
        width="840"
        height="610"
        show-zoom
        resize
        remember
        :fullscreen="true"
    >
        <template #default> sss </template>
    </vxe-modal>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
    defineExpose,
} from "vue";
import { useRouter } from "vue-router";
import { VXETable } from "vxe-table";
import Qs from "qs";
import comVersion from "./comVersion.vue";

const router = useRouter();
const { proxy } = getCurrentInstance();
const isShow = ref(false);

const auditAPP = () => {
    isShow.value = true;
};

defineExpose({ auditAPP });
</script>
<style scoped></style>
